import { httpClient } from '../httpClient';

export const organizationApi = {
  /** GET /organization/profile — returns singleton org profile or null */
  getProfile: () =>
    httpClient.get('/organization/profile'),

  /** PUT /organization/profile — create or update the singleton profile */
  upsertProfile: (data) =>
    httpClient.put('/organization/profile', data),

  /** GET /organization/export — export-readiness validation result */
  getExportValidation: () =>
    httpClient.get('/organization/export'),

  /**
   * GET /organization/export/package?format=pdf|xlsx
   * M-BE-6 — signed SDAIA submission package. Returns the binary
   * artifact + the X-PG-Submission-{SHA256,Signature,KeyVersion} integrity
   * headers. We request blob + ask the httpClient to expose the headers
   * so the UI can display the SHA-256 next to the download.
   */
  exportSubmissionPackage: (format = 'pdf') =>
    httpClient.get('/organization/export/package', {
      params: { format },
      responseType: 'blob',
    }),

  /**
   * GET /organization/export/manifest
   * M-BE-6 — JSON manifest with canonical payload + signature.
   */
  exportSubmissionManifest: () =>
    httpClient.get('/organization/export/manifest'),

  /**
   * GET /organization/export/internal-pdf?lang=en|ar
   * T279/T281 (FR-031) — server-rendered internal-review org-profile PDF
   * (unsigned; banner reads "INTERNAL REVIEW — NOT FOR SUBMISSION"). Replaces
   * the client jsPDF render. Distinct from the HMAC-signed submission package.
   */
  exportInternalPdf: (lang) =>
    httpClient.get('/organization/export/internal-pdf', {
      params: { lang },
      responseType: 'blob',
    }),

  /** GET /organization/sectors — static list of industry sectors */
  getSectors: () =>
    httpClient.get('/organization/sectors'),

  /**
   * POST /organization/profile/retention-declaration
   * S7-B (Lane B2) — records the authorized-human affirmation that no
   * sector retention overlay applies to this install. Body: { note? }.
   */
  declareRetention: (note) =>
    httpClient.post('/organization/profile/retention-declaration', note ? { note } : {}),

  /**
   * DELETE /organization/profile/retention-declaration
   * Withdraws the affirmation above.
   */
  withdrawRetentionDeclaration: () =>
    httpClient.delete('/organization/profile/retention-declaration'),
};
